import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonUtils} from "../../utils/common";
import {ClientsService} from "../../providers/clients.service";
import {AppStateService} from "../../providers/app-state.service";
import {AlertController, ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {Client, ClientReportType} from "../../models/client.model";
import {mobilePhoneNumberValidator, mustMatch, noWhitespaceValidator, pwdValidator} from "../../utils/form-validators";
import {UserService} from "../../providers/user.service";
import {Subscription} from "rxjs";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {VetClinic} from "../../models/vet-clinic.model";
import {User} from "../../models/user.model";
import {GdprTermPlaceholderComponent} from "../gdpr-term-placeholder/gdpr-term-placeholder.component";
import {GdprTerms} from "../../models/gdpr-terms.model";
import {GdprTermsService} from "../../providers/gdpr-terms.service";
import {TermsOfAgreement} from "../../models/terms-of-agreement.model";
import {InformationObligation} from "../../models/information-obligation.model";

@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.scss'],
})
export class EditClientComponent extends GenericActionComponent implements OnInit, GenericActionComponentsMethods, OnDestroy {

  @Input() client: Client;
  @Input() canBeEdited: boolean;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<Client>();
  @Output() objectAddedEmitter = new EventEmitter<Client>();
  articleEnabled: boolean = false;
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();
  isGeneralAdmin: boolean;
  businessType: string;
  isAdmin: boolean;
  userSub: Subscription;
  clinics: VetClinic[];
  vetCodeToImport: string;
  clinicSub: Subscription;
  userGroup: FormGroup;
  pwdType: string = 'password';
  showPwdIcon: string = 'eye-off-outline';
  pwdSub: Subscription;
  clientSub: Subscription;
  timeSub: Subscription;
  importDataSub: Subscription;

  hasFakturowniaSection: boolean = false;
  hasUnsavedChanges: boolean = false;
  gdprTerms: GdprTerms;
  printPdfSub: Subscription;
  toas: TermsOfAgreement[];
  iobs: InformationObligation[];
  isGeneralClientAdmin: boolean;
  individualTermsSub: Subscription;
  hasVetcodeId: boolean = false;
  sendEmailWithClientReports: boolean;
  protected reportForm: FormGroup;
  public isReportConfigIdentical: boolean;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private clientService: ClientsService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private userService: UserService,
    private vetClinicService: VetClinicService,
    private alertController: AlertController,
    private gdprTermsService: GdprTermsService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralAdmin = this.isAdmin && this.user.vClientId === null && this.user.vetcodeId === null;
    this.isGeneralClientAdmin = this.user.vClientId === null && this.user.vetcodeId === null;
    this.hasVetcodeId = this.user.vetcodeId !== null;
    console.log(this.isGeneralClientAdmin)
    console.log(this.client)
    if (this.client.type === 'VET_CLINIC') {
      this.refreshClinics();
    }

    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nowego klienta';
      this.actionBtnLabel = 'Dodaj klienta';
      this.actionQuestion = 'Na pewno chcesz dodać klienta?';
      this.actionSuccess = 'Klient został dodany';
      this.actionError = 'Wystąpił błąd podczas dodawania klienta'
      this.handleForm();
      this.userGroup = this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        mobilePhone: ['', [Validators.required, mobilePhoneNumberValidator]],
        email: ['', Validators.email],
        password: ['', [Validators.required, pwdValidator]],
        retypePassword: ['', Validators.required]
      }, {validators: mustMatch('password', 'retypePassword')});
    } else {
      if (!this.client.gdprApproved) {
        this.appStateService.updateIsBusySubject(true)
        this.importDataSub = this.clientService.importDataFromP24(this.client.uuid).subscribe(cl => {
          this.appStateService.updateIsBusySubject(false)
          if (cl) {
            this.client = cl;
            if(this.client.businessType){
              this.businessType= this.client.businessType.toString();
            }
            this.handleForm();
          }
        }, error => {
          this.appStateService.updateIsBusySubject(false)
        })
      }

      if(this.client.businessType){
        this.businessType = this.client.businessType + '';
      }

      if (this.client.gdprApproved) {
        this.componentTitle = 'Zmień dane konta klienta';
        this.actionBtnLabel = 'Zmień dane konta klienta';
        this.actionQuestion = 'Na pewno chcesz zmienić dane konta klienta?';
        this.actionSuccess = 'Dane klienta zostały zmienione';
        this.actionError = 'Wystąpił błąd podczas zmiany danych konta klienta';
        this.sendEmailWithClientReports = this.client.sendEmailWithClientReports;
        this.handleReportForm();
      } else {
        this.componentTitle = 'Zapisz dane konta klienta';
        this.actionBtnLabel = 'Zapisz dane konta klienta';
        this.actionQuestion = 'Na pewno chcesz zapisać dane konta klienta?';
        this.actionSuccess = 'Dane klienta zostały zapisane';
        this.actionError = 'Wystąpił błąd podczas zapisywania danych konta klienta';
      }
      this.handleForm();

    }

    if (this.client?.gdprApproved) {
      this.gdprTermsService.getActiveTerms(this.client.uuid).subscribe(gdprTerms => {
        if (gdprTerms) {
          this.gdprTerms = gdprTerms;
        }
      });
    }

    super.ngOnInit();

    if (this.client.type === 'VET_CLINIC') {
      this.clientService.getDocuments(this.client.uuid).subscribe(docResponse => {
        if (docResponse) {
          this.iobs = docResponse.iobs;
          this.toas = docResponse.toas;
        }
      });
    }
  }

  getIobForClinic(vetcodeId) {
    return this.iobs?.filter(iob => iob.vetcodeId===vetcodeId)[0];
  }

  getToaForClinic(vetcodeId) {
    return this.toas?.filter(toa => toa.vetcodeId===vetcodeId)[0];
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.appStateService.updateEditMode('CHANGED');
      this.hasUnsavedChangesEmitter.emit(true);
    }
  }

  paymentsEnabled(){
    if (this.clinics){
      const res = this.clinics?.filter(e=>e.paymentsEnabled).length >=1;
      console.log('payments')
      if (res) {
        this.hasFakturowniaSection = true;
      }
      return res;
    } else {
      return false;
    }
  }

  onSelectBusinessType($event) {
    this.appStateService.updateIsBusySubject(true);
    this.businessType = $event.detail.value;
    if (this.isKrsNeeded()) {
      if (this.client?.uuid) {
        this.formGroup.addControl('krs', new FormControl(this.client.krs, [Validators.required, this.noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
      } else {
        this.formGroup.addControl('krs', new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
      }
    } else {
      this.formGroup.removeControl('krs');
      this.client.krs = null;
    }
    this.appStateService.updateIsBusySubject(false);
    this.markUnsavedChanges();
  }

  handleForm() {
    if (this.action === 'ADD') {
      this.formGroup = this.formBuilder.group({
        name: ['', [Validators.required, noWhitespaceValidator]],
        email: ['', [Validators.email, Validators.required, noWhitespaceValidator]],
        phone: ['', [Validators.required, mobilePhoneNumberValidator, noWhitespaceValidator]],
        taxId: ['', [Validators.required, noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]],
        regon: ['', [Validators.required, noWhitespaceValidator, Validators.minLength(9)]],
        streetWithNumber: ['', [Validators.required, noWhitespaceValidator]],
        city: ['', [Validators.required, noWhitespaceValidator]],
        postalCode: ['', [Validators.required, noWhitespaceValidator]],
      })
      if (this.isKrsNeeded()) {
        this.formGroup.addControl('krs', new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
      }
      if (this.isGeneralAdmin || this.isGeneralClientAdmin) {
        this.formGroup.addControl('type', new FormControl('', Validators.required));
      }
    } else {
      this.formGroup = this.formBuilder.group({
        name: [this.client.name, [Validators.required, this.noWhitespaceValidator]],
        email: [this.client.email, [Validators.email, Validators.required, this.noWhitespaceValidator]],
        phone: [this.client.phone, [Validators.required, mobilePhoneNumberValidator, this.noWhitespaceValidator]],
        taxId: [this.client.taxId, [Validators.required, this.noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]],
        regon: [this.client.regon, [Validators.required, this.noWhitespaceValidator, Validators.minLength(9)]],
        streetWithNumber: [this.client.streetWithNumber, [Validators.required, this.noWhitespaceValidator]],
        city: [this.client.city, [Validators.required, this.noWhitespaceValidator]],
        postalCode: [this.client.postalCode, [Validators.required, this.noWhitespaceValidator]],
      });
      if (this.isKrsNeeded()) {
        this.formGroup.addControl('krs', new FormControl(this.client.krs, [Validators.required, this.noWhitespaceValidator, Validators.minLength(10), Validators.maxLength(10)]));
      }


      if (this.isGeneralAdmin) {
        this.formGroup.addControl('onlineTransactionFee', new FormControl(this.client.onlineTransactionFee, Validators.required));
        this.formGroup.addControl('percentageOnlineTransactionFee', new FormControl(this.client.percentageOnlineTransactionFee, Validators.required));
        this.formGroup.addControl('visitTransactionFee', new FormControl(this.client.visitTransactionFee, Validators.required));
        this.formGroup.addControl('percentageVisitTransactionFee', new FormControl(this.client.percentageVisitTransactionFee, Validators.required));
        this.formGroup.addControl('type', new FormControl(this.client.type, Validators.required));
      }
    }
  }

  onAction() {
    if ((this.action === 'EDIT' && this.formGroup.valid) || (this.action === 'ADD' && this.formGroup.valid && this.userGroup.valid)) {
      let text = 'Na pewno chcesz zapisać zmiany?';
      if (this.action === 'EDIT') {
        if (this.client.gdprApproved) {
          text = 'Na pewno chcesz zapisać zmiany? Pamiętaj aby następnie przygotować i zaakceptować nową umowę powierzenia danych praz skontaktować się z obsługą Vetineo';
        }
      }
      this.commonUtils.presentYesNoActionSheet(text, 'Tak', 'Nie', 'checkmark', 'close', () => {
        let clientObj: Client = this.commonUtils.formGroupValuesToObject<Client>(new Client(), this.formGroup);

        let serviceMethod;

        if (this.action === 'EDIT') {
          clientObj.id = this.client.id;
          clientObj.uuid = this.client.uuid;
          clientObj.vetCodeId = this.client.vetCodeId;
          clientObj.businessType = Number.parseInt(this.businessType);
          if (!this.isKrsNeeded()) {
            clientObj.krs = null;
          }
          this.appStateService.updateIsBusySubject(true);
          this.clientSub = this.clientService.updateClient(clientObj).subscribe(clUpdated => {
            this.appStateService.updateIsBusySubject(false)
            if (clUpdated) {
              this.client = clUpdated;
              this.hasUnsavedChanges = false;
              this.commonUtils.presentInfoToast('Dane klienta zostały zmienione')
            } else {
              this.commonUtils.presentAlertToast('Wystąpił błąd podczas zmieniania danych klienta')
            }
          }, error => {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas zmieniania danych klienta')
            this.appStateService.updateIsBusySubject(false);
          });
        } else {
          clientObj.businessType = Number.parseInt(this.businessType);
          let userAdded: User = this.commonUtils.formGroupValuesToObject<User>(new User(), this.userGroup);
          userAdded.roles = 'admin'
          clientObj.admin = userAdded;
          this.clientSub = this.clientService.addClient(clientObj).subscribe(clUpdated => {
            this.appStateService.updateIsBusySubject(false)
            if (clUpdated) {
              this.client = clUpdated;
              this.objectAddedEmitter.emit(this.client);
              this.commonUtils.presentInfoToast('Dane klienta zostały dodane')
            } else {
              this.commonUtils.presentAlertToast('Wystąpił błąd podczas dodawania danych klienta');
            }
          }, error => {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas dodawania danych klienta');
            this.appStateService.updateIsBusySubject(false);
          });
        }

      }, () => {
      });
    }
  }

  checkFormsValid() {
    if (this.action === 'EDIT' && this.formGroup.valid) {
      return true;
    }

    if (this.action === 'ADD' && this.formGroup.valid && this.userGroup?.valid) {
      return true;
    }
    return false;
  }

  isKrsNeeded() {
    return Number.parseInt(this.businessType) > 3 && Number.parseInt(this.businessType) != 12;
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : {'whitespace': true};
  }

  async importClinic() {
    const alert = await this.alertController.create({
      header: 'Importuj lecznicę',
      inputs: [
        {
          placeholder: 'vetCode',
          name: 'vetCode',
          type: 'number',
          attributes: {
            required: true
          }
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (dt) => {
            if (!dt?.vetCode) return false;
            this.appStateService.updateIsBusySubject(true);
            let vetCode = dt.vetCode as string;

            this.vetClinicService.checkIfNotExist(vetCode).subscribe(e => {
              if (e) {
                this.processImport(e);
              }
            }, error => {
              let errorMsg = error.error.errors.main;

              if (errorMsg === 'NULL_VETCODE') {
                this.commonUtils.presentAlertToast(`Pusty VetCode`);
              }
              if (errorMsg === 'VET_CLINIC_EXIST') {
                this.commonUtils.presentAlertToast(`Lecznica o podanym VetCode = ${dt?.vetCode} istnieje`);
              }
              if (errorMsg === 'CLIENT_EXIST') {
                this.commonUtils.presentAlertToast(`Klient lecznicy o podanym VetCode = ${dt?.vetCode} istnieje`);
              }

              this.appStateService.updateIsBusySubject(false);
            })
          }
        }
      ]
    });

    await alert.present();
  }

  private refreshClinics() {
    this.appStateService.updateIsBusySubject(true);
    this.clinicSub = this.vetClinicService.listClinicsForClient(this.client.uuid).subscribe(e => {
      this.clinics = e;
      this.appStateService.updateIsBusySubject(false)
    }, error => {
      this.appStateService.updateIsBusySubject(false)
    })
  }

  private processImport(e: string) {
    this.appStateService.updateIsBusySubject(true);
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz importować lecznicę?', 'Tak', 'Nie', 'checkmark', 'close', () => {

      this.userService.importClinicForExistingClient(this.client.uuid, e).subscribe(clinic => {
        this.appStateService.updateIsBusySubject(false);
        if (clinic) {
          if (this.clinics) {
            this.clinics.push(clinic);
          } else {
            this.clinics = [];
            this.clinics.push(clinic);
          }
          this.commonUtils.presentInfoToast("Klinika zaimportowana poprawnie").then(res => {
          });
        } else {
          this.commonUtils.presentAlertToast("Wystąpił błąd podczas importowania kliniki");
        }
      }, error => {
        this.appStateService.updateIsBusySubject(false);
        let errorMsg = error.error.errors.main;
        if (errorMsg === 'USER_NOT_FOUND') {
          this.commonUtils.presentAlertToast('Brak zalogowanego użytkownika');
        }
        if (errorMsg === 'USER_UNAUTHORIZED') {
          this.commonUtils.presentAlertToast('Nie masz uprawnień');
        }
        if (errorMsg === 'BAD_VCLIENT') {
          this.commonUtils.presentAlertToast('Klient nie isnieje');
        }
        if (errorMsg === 'EMAIL_ALREADY_EXIST') {
          this.commonUtils.presentAlertToast('Użytkownik o podanym adresie email istnieje');
        }
        if (errorMsg === 'PHONE_ALREADY_EXIST') {
          this.commonUtils.presentAlertToast('Użytkownik o podanym nr. telefonu istnieje');
        }
        if (errorMsg === 'EXCEPTION_DURING_ADDING') {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas dodawania');
        }
        if (errorMsg === 'CLINIC_IMPORT_FAILED') {
          this.commonUtils.presentAlertToast(`Wystąpił błąd importu`);
        }
        if (errorMsg === 'NULL_VETCODE') {
          this.commonUtils.presentAlertToast(`Pusty VetCode`);
        }
        if (errorMsg === 'VET_CLINIC_EXIST') {
          this.commonUtils.presentAlertToast(`Lecznica o podanym VetCode istnieje`);
        }
        if (errorMsg === 'CLIENT_EXIST') {
          this.commonUtils.presentAlertToast(`Klient lecznicy o podanym VetCode istnieje`);
        }
      });

    }, () => {
    });
  }

  onChangePwdType() {
    if(this.pwdType === 'password'){
      this.pwdType = 'text';
      this.showPwdIcon = 'eye-outline';
    } else {
      this.pwdType = 'password';
      this.showPwdIcon = 'eye-off-outline';
    }
  }

  generatePwd() {
    this.appStateService.updateIsBusySubject(true);
    this.pwdSub = this.userService.generatePwd().subscribe(pwd => {
      if (pwd) {
        this.pwdType = 'text';
        this.showPwdIcon = 'eye-outline';
        this.userGroup.controls.password.markAsTouched();
        this.userGroup.controls.password.setValue(pwd);
        this.userGroup.controls.retypePassword.setValue(pwd);
        this.commonUtils.presentInfoToast('Twoje hasło zostało wygenerowane');
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd');
      }
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd');
      this.appStateService.updateIsBusySubject(false);
    });

  }

  hasAllNeededDataForAgreement() {
    let simpleDataResult = this.client && this.client.streetWithNumber !== undefined && this.client.city  !==undefined && this.client.taxId  !==undefined
      && this.client.name  !==undefined && this.client.postalCode  !==undefined;
    return (this.isKrsNeeded() ?  this.formGroup.valid? true : simpleDataResult && this.client.krs !== undefined : this.formGroup.valid? true : simpleDataResult) && this.businessType;
      // (simpleDataResult || this.formGroup.valid) && this.client.krs !== undefined : (simpleDataResult || this.formGroup.valid);
  }

  prepareAgreement() {
    if(this.formGroup.valid && this.businessType){

      if (this.client.individualGDPRTermsUUID) {
        this.appStateService.updateIsBusySubject(true);
        this.individualTermsSub = this.gdprTermsService.getIndividualTerms().subscribe(terms => {
          this.appStateService.updateIsBusySubject(false);
          if (terms && terms.template) {
            this.prepareAgreementModal(terms.template);
          } else {
            this.commonUtils.presentAlertToast('Nie można pobrać regulaminu indywidualnego');
          }}, error => {
          this.commonUtils.presentAlertToast('Nie można pobrać regulaminu indywidualnego');
          this.appStateService.updateIsBusySubject(false);
          }
        );
      } else {
        this.commonUtils.presentYesNoActionSheet('Czy potwierdzasz poprawność wszystkich danych zawartych w formularzu? Na ich podstawie przygotujemy umowę powierzenia danych.', 'Tak', 'Nie', 'checkmark', 'close', () => {
          this.appStateService.updateIsBusySubject(true);
          let clientObj: Client = this.commonUtils.formGroupValuesToObject<Client>(new Client(), this.formGroup);

          clientObj.id = this.client.id;
          clientObj.uuid = this.client.uuid;
          clientObj.vetCodeId = this.client.vetCodeId;
          clientObj.businessType = Number.parseInt(this.businessType);
          if (!this.isKrsNeeded()) {
            clientObj.krs = null;
          }
          this.clientSub = this.clientService.updateClient(clientObj).subscribe(clUpdated => {
            if (clUpdated) {
              this.client = clUpdated;
              this.hasUnsavedChanges = false;
              this.gdprTermsService.getTemplate().subscribe(template => {
                this.prepareAgreementModal(template);
                this.appStateService.updateIsBusySubject(false);
              }, error => {
                this.appStateService.updateIsBusySubject(false);
              })
            } else {
              this.appStateService.updateIsBusySubject(false);
              this.commonUtils.presentAlertToast('Wystąpił błąd podczas akceptacji i zapisu danych klienta')
            }
          }, error => {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas akceptacji i zapisu danych klienta')
            this.appStateService.updateIsBusySubject(false);
          });
        }, () => {
        });
      }
    } else {
      this.commonUtils.presentAlertToast('Popraw lub uzupełnij dane')
    }

  }

  showActiveAgreement() {
    this.appStateService.updateIsBusySubject(true);
    this.gdprTermsService.getActiveAgreement(this.client.uuid).subscribe(gdprTerms => {
      this.prepareAgreementModal(gdprTerms, 'show');
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    })
  }

  async prepareAgreementModal(terms, mode: string = 'create') {
    let acceptanceDate;
    if (!this.clinics || this.clinics.length === 0) {
      this.appStateService.updateIsBusySubject(true);
      this.timeSub = this.gdprTermsService.getServerTime().subscribe(serverTime => {
        this.appStateService.updateIsBusySubject(false);
        if (serverTime) {
          this.prepareModal(mode, terms, serverTime, serverTime);
        } else {
          this.commonUtils.presentAlertToast('Nie można aktualnie zaakceptować umowy powierzenia danych, spróbuj ponownie');
        }
      }, error => {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast('Nie można aktualnie zaakceptować umowy powierzenia danych, spróbuj ponownie');
      });
    } else {
      let vetineoStartDate = this.clinics.sort((a, b) => {
        return new Date(a?.vetineoStartDate)?.getTime() - new Date(b?.vetineoStartDate)?.getTime()
      })[0]?.vetineoStartDate;
      if (vetineoStartDate) {
        console.log(vetineoStartDate)
        this.timeSub = this.gdprTermsService.getServerTime().subscribe(serverTime => {
          this.appStateService.updateIsBusySubject(false);
          if (serverTime) {
            this.prepareModal(mode, terms, vetineoStartDate, serverTime);
          } else {
            this.commonUtils.presentAlertToast('Nie można aktualnie zaakceptować umowy powierzenia danych, spróbuj ponownie');
          }
        }, error => {
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentAlertToast('Nie można aktualnie zaakceptować umowy powierzenia danych, spróbuj ponownie');
        })
      } else {
        this.appStateService.updateIsBusySubject(true);
        this.timeSub = this.gdprTermsService.getServerTime().subscribe(serverTime => {
          this.appStateService.updateIsBusySubject(false);
          if (serverTime) {
            this.prepareModal(mode, terms, serverTime, serverTime);
          } else {
            this.commonUtils.presentAlertToast('Nie można aktualnie zaakceptować umowy powierzenia danych, spróbuj ponownie');
          }
        }, error => {
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentAlertToast('Nie można aktualnie zaakceptować umowy powierzenia danych, spróbuj ponownie');
        });
      }
    }
  }

  async prepareModal(mode, terms, acceptanceDate, generatedDate) {
    const modal = await this.modalController.create({
      component: GdprTermPlaceholderComponent,
      componentProps: {
        'vClientData': this.client,
        'mode': mode,
        'gdrpTerms': terms,
        'acceptanceDate': acceptanceDate,
        'generatedDate': generatedDate,
        'gdpr':this.gdprTerms
      },
      cssClass: "full-modal"
    });

    modal.onDidDismiss<GdprTerms>().then((dismissData) => {
      if (dismissData && dismissData?.data) {
        this.refreshClient();
      }
    });
    return await modal.present();
  }

  refreshClient() {
    this.appStateService.updateIsBusySubject(true);
    this.clientService.getClientByUUID(this.client.uuid).subscribe(e => {
      if (e) {
        this.client = e;
      }
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    })
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.clientSub) {
      this.clientSub.unsubscribe();
    }
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
    if (this.pwdSub) {
      this.pwdSub.unsubscribe();
    }
    if (this.clinicSub) {
      this.clinicSub.unsubscribe();
    }
    if (this.timeSub) {
      this.timeSub.unsubscribe();
    }
    if (this.importDataSub) {
      this.importDataSub.unsubscribe();
    }
    if (this.printPdfSub) {
      this.printPdfSub.unsubscribe();
    }

    if (this.individualTermsSub) {
      this.individualTermsSub.unsubscribe();
    }
  }

  isGdprAgreementSigned(): boolean {
    return this.client?.gdprApproved !== undefined && this.client?.gdprApproved !== '';
  }

  openFakturowniaTermsOfAgreement() {
    window.open('https://fakturownia.pl/regulamin', '_blank');
  }

  acceptFakturowniaAgreement() {
    this.commonUtils.presentYesNoActionSheet('Czy potwierdzasz, że zapoznałeś/zapoznałaś się i akceptujesz regulamin serwisu Fakturownia.pl?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      this.vetClinicService.acceptFakturowniaTerm().subscribe(client => {
        if (client) {
          this.client = client;
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentInfoToast('Dziękujemy za potwierdzenie regulaminu Fakturownia.pl')
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas potwierdzania regulaminu Fakturownia.pl')
          this.appStateService.updateIsBusySubject(false);

        }
      }, error => {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas potwierdzania regulaminu Fakturownia.pl')
        this.appStateService.updateIsBusySubject(false);
      })
    }, () => {
      this.commonUtils.presentYesNoActionSheet('Czy chcesz zapoznałać się z regulaminem serwisu Fakturownia.pl?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.openFakturowniaTermsOfAgreement()
      }, () => {
      });
    });
  }

  cancelAgreement() {
    this.commonUtils.presentYesNoActionSheet('Czy potwierdzasz, że chcesz anulować akceptację umowy powierzenia danych?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      this.gdprTermsService.cancelTerms(this.client.uuid).subscribe(vClient => {
        if (vClient) {
          this.client = vClient;
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentInfoToast('Zgoda została anulowana')
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas anulowania zgody')
          this.appStateService.updateIsBusySubject(false);

        }
      }, error => {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas anulowania zgody')
        this.appStateService.updateIsBusySubject(false);
      })
    }, () => {
    });
  }

  downloadPdf() {
    this.appStateService.updateIsBusySubject(true);

    this.printPdfSub = this.gdprTermsService.printGdprPdf(this.client.uuid, this.gdprTerms.uuid).subscribe(signedUrl => {
      this.appStateService.updateIsBusySubject(false);
      if (signedUrl) {
        window.open(signedUrl, '_blank');
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobieranie umowy powierzenia danych w formacie PDF');
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobieranie umowy powierzenia danych w formacie PDF');
    });
  }

  onReportsChange($event: any) {
    if ($event.detail.checked) {
      this.handleReportForm();
    } else {
      this.reportForm.reset();
    }
  }


  get emailsArray(): FormArray {
    return this.reportForm?.get('emails') as FormArray;
  }

  private createEmailControl(formState = '') {
    return this.formBuilder.control(formState, [
      Validators.required,
      Validators.email
    ]);
  }

  addNewReportEmail() {
    this.emailsArray.push(this.createEmailControl());
  }

  removeEmail(idx: number) {
    this.emailsArray.removeAt(idx);
  }

  isEmailInvalid(idx: number): boolean {
    const control = this.emailsArray.at(idx);
    return control.invalid && (control.dirty || control.touched);
  }

  private handleReportForm() {
    const controlArray :FormControl[] = [];
    const reportEmailString = this.client.clientReportsEmails;
    if (reportEmailString) {
      const reportEmails = reportEmailString.split(';');
      for (let reportEmail of reportEmails) {
        controlArray.push(this.createEmailControl(reportEmail));
      }
    } else {
      controlArray.push(this.createEmailControl());
    }

    this.reportForm = this.formBuilder.group({
      reportType: [this.client.vClientReportType, Validators.required],
      emails: this.formBuilder.array(controlArray)
    });
    this.reportForm.valueChanges.subscribe(() => {
      this.isIdenticalReportConfig();
    });

    this.isIdenticalReportConfig();
  }

  async onSaveClientReport() {
    const reqObj = this.getCurrentReportConfigObject();
    try {
      const response = await this.clientService.updateReportConfiguration(reqObj).toPromise()
      if (response) {
        this.commonUtils.presentInfoToast("Pomyślnie zapisano ustawienia raportów");
        this.client.sendEmailWithClientReports = reqObj.sendEmailWithClientReports;
        this.client.vClientReportType = reqObj.vClientReportType;
        this.client.clientReportsEmails = reqObj.clientReportsEmails;
        this.isIdenticalReportConfig();
      }
    } catch (e) {
      this.commonUtils.presentAlertToast("Wystąpił błąd podczas zapisywania ustawień raportów");
    }
  }

  resignFromReports() {
    const reqObj = {
      uuid: this.client.uuid,
      sendEmailWithClientReports: this.sendEmailWithClientReports
    }
      this.commonUtils.presentYesNoActionSheet('Czy chcesz zrezygnować z funkcjonalności raportów?', 'Tak', 'Nie', 'checkmark-outline', 'close', async () => {
        try {
          const response = await this.clientService.updateReportConfiguration(reqObj).toPromise()
          if (response) {
            this.commonUtils.presentInfoToast("Pomyślnie zrezygnowano z raportów");
            this.client.sendEmailWithClientReports = false;
            this.client.vClientReportType = undefined;
            this.client.clientReportsEmails = undefined;
          }
        } catch (e) {
          this.commonUtils.presentAlertToast("Wystąpił błąd podczas rezygnacji z raportów");
        }
      }, () => {
      });

  }

  isIdenticalReportConfig() {
    if (!this.sendEmailWithClientReports) {
      this.isReportConfigIdentical = false;
      return;
    }
    const formConfig = this.getCurrentReportConfigObject();
    this.isReportConfigIdentical = (this.client.clientReportsEmails == formConfig.clientReportsEmails && this.client.vClientReportType === formConfig.vClientReportType);
  }

  private getCurrentReportConfigObject() {
    const reportDataObj = this.reportForm.getRawValue();
    console.log(reportDataObj);
    const emailString = reportDataObj.emails.map(email => email.trim()).join(';');
    return {
      uuid: this.client.uuid,
      clientReportsEmails: emailString,
      vClientReportType: reportDataObj.reportType,
      sendEmailWithClientReports: this.sendEmailWithClientReports
    }
  }
}
